import {React, observer, useEffect, classNames, useAsObservableSource} from '@api'
import {EmersyaViewerProps, EmersyaViewerStore, useFieldRendererStore} from '@design-board/stores'
import {useVipLocalStore} from '@modules'
import * as css from './Emersya3dViewer.css'

export const Emersya3dViewer = observer<EmersyaViewerProps>(function Emersya3dViewer(props) {
  const fieldRendererStore = useFieldRendererStore(),
    {className} = props,
    {detailsStore, detailsStore: {modal, selectedDetailTab, data}, tabId} = fieldRendererStore,
    obsProps = useAsObservableSource(props),
    store = useVipLocalStore((ws) => new EmersyaViewerStore(ws, fieldRendererStore, obsProps)),
    {onLoad, loading, loaded, onFullScreenChange, isFullScreen, selectModel, selectedModel, appAndCode, message, messageVisible, field3d, useExternalUrl} = store

  //console.log(selectedModel)

  useEffect(() => {
    selectModel(props.selectedModel || _.first(data?.style?.colorways))
  }, [])

  useEffect(() => {
    document.addEventListener('fullscreenchange', onFullScreenChange, false)

    return () => {
      document.removeEventListener('fullscreenchange', onFullScreenChange)
    }
  }, [])

  useEffect(() => {
    if (!props.selectedModel && tabId == selectedDetailTab?.id) {
      modal.extraTabHeader = store.menuButtons

      return () => {
        modal.extraTabHeader = null
      }
    }
  }, [selectedDetailTab, selectedModel, loaded])

  const href = useExternalUrl ? field3d : `https://emersya.com/app/${appAndCode}`

  return <div className={classNames(className, css.root)} data-external-url={useExternalUrl} data-has-configurator={true} data-loading={loading} data-loaded={loaded} data-is-full-screen={isFullScreen}>
    {/*<div className={css.actions}>
      <Button minimal={false} disabled={!loaded} text='Take Screenshot' onClick={getScreenshot}/>
      <Button disabled={!loaded} icon='saved' text='Save configuration' onClick={() => saveConfiguration({})}/>
      <Button disabled={!loaded} icon='plus' text='Add annotation' onClick={getScreenshot}/>
      <Button disabled={!loaded} icon='trash' text='Remove annotation' onClick={getScreenshot}/>
      <Button disabled={!loaded} icon='camera' text='Take Screenshot' onClick={getScreenshot}/>
    </div>*/}

    {selectedModel && <iframe
	    onLoad={onLoad}
	    src={
          //`https://emersya.com/showcase/${code}`
          href
        }
	    frameBorder={0}
	    allowFullScreen/>
    }
    <div className={css.message}>
      <span className={css.text} data-visible={messageVisible}>{message}</span>
    </div>
  </div>
})



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/Emersya3dViewer.tsx